import React from 'react';

const TONES = {
  emerald: { icon: 'bg-emerald-50 text-emerald-700', value: 'text-emerald-700', bar: 'bg-emerald-500' },
  rose: { icon: 'bg-rose-50 text-rose-700', value: 'text-rose-700', bar: 'bg-rose-500' },
  sky: { icon: 'bg-sky-50 text-[#176B91]', value: 'text-[#176B91]', bar: 'bg-[#176B91]' },
  amber: { icon: 'bg-amber-50 text-amber-700', value: 'text-amber-700', bar: 'bg-amber-500' },
  indigo: { icon: 'bg-indigo-50 text-indigo-700', value: 'text-indigo-700', bar: 'bg-indigo-500' },
  slate: { icon: 'bg-slate-100 text-slate-700', value: 'text-slate-900', bar: 'bg-slate-400' },
};

/** Kurumsal KPI kartı — tüm finans ve operasyon ekranlarında ortak. */
export const StatCard = ({ icon: Icon, label, value, sub, tone = 'slate', onClick, testid }) => {
  const t = TONES[tone] || TONES.slate;
  const Tag = onClick ? 'button' : 'div';
  return (
    <Tag
      onClick={onClick}
      data-testid={testid}
      className={`relative overflow-hidden text-left w-full bg-white rounded-xl border border-[#E2E8F0] shadow-sm transition-shadow ${onClick ? 'hover:shadow-md cursor-pointer' : 'hover:shadow-md'}`}
    >
      <span className={`absolute left-0 top-0 bottom-0 w-[3px] ${t.bar}`} />
      <div className="flex items-start gap-3 p-4 pl-5">
        {Icon && <div className={`rounded-xl p-2.5 shrink-0 ${t.icon}`}><Icon className="w-5 h-5" /></div>}
        <div className="min-w-0">
          <p className="text-[11px] uppercase tracking-wide text-slate-500 font-semibold truncate">{label}</p>
          <p className={`text-xl font-bold tracking-tight ${t.value}`}>{value}</p>
          {sub && <p className="text-[11px] text-slate-500 mt-0.5 truncate">{sub}</p>}
        </div>
      </div>
    </Tag>
  );
};

export default StatCard;
